import { Box, Typography, Container } from "@mui/material";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function CorporateResponsibility() {
  return (
    <Box
      sx={{
        py: { xs: 7, md: 10 },
        background: `linear-gradient(135deg, #f7f9fc 0%, #eef1f8 100%)`,
      }}
    >
      <Container maxWidth="lg">
        {/* Title */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: 1,
            textAlign: "left",
            color: brandBlue,
            fontSize: { xs: "1.8rem", md: "2.3rem" },
          }}
        >
          Corporate Responsibility
        </Typography>

        {/* Underline */}
        <Box
          sx={{
            width: 90,
            height: 4,
            background: brandRed,
            borderRadius: 3,
            mb: 5,
          }}
        />

        {/* Content Card */}
        <Box
          sx={{
            maxWidth: 900,
            p: { xs: 3, md: 4 },
            pl: { xs: 4, md: 5 },
            borderLeft: `5px solid ${brandBlue}`,
            borderRadius: "14px",
            background: "rgba(255,255,255,0.7)",
            backdropFilter: "blur(8px)",
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            transition: "0.3s",
            "&:hover": {
              transform: "translateY(-5px)",
              boxShadow: "0 18px 40px rgba(0,0,0,0.12)",
            },
          }}
        >
          <Typography
            sx={{
              color: "#444",
              lineHeight: 1.7,
              fontSize: "1.05rem",
            }}
          >
            We are committed to responsible and ethical operations across every stage of our manufacturing process. This includes maintaining safe work environments, adopting sustainable production practices, reducing environmental impact, and ensuring full compliance with industry standards. We actively support community welfare initiatives and continuously invest in staff training and development to promote a safe, skilled, and empowered workforce.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
